import type { AxiosError } from 'axios'

import type { TipoDeNotificacao } from '@/enums/tipo-de-notificacao'
import type { Notificacao } from '@/models'

export const QUANTIDADE_DE_NOTIFICACOES_POR_PAGINA = 30

export const FORMATO_DA_DATA_DA_NOTIFICACAO = "dd/MM/yyyy 'às' HH:mm"

export interface ParametrosDaNotificacaoApi {
  id_documento?: number
}

export interface NotificacaoApi {
  id: number
  tipo: TipoDeNotificacao
  descricao: string
  data: string
  visualizado_em?: string | null
  parametros?: ParametrosDaNotificacaoApi | null
}

export interface RespostaDeNotificacoesApi {
  resultados: NotificacaoApi[]
  tem_mais: boolean
}

export interface PaginaDeNotificacoes {
  resultado: Notificacao[]
  temMais: boolean
}

export type ObterNotificacoesResposta = [
  (pagina: number) => Promise<PaginaDeNotificacoes | null>,
  { loading: boolean; erro: AxiosError | null },
]

export type MarcarNotificacaoComoVisualizadaResposta = [
  (idDaNotificacao: number) => Promise<boolean>,
  { loading: boolean; erro: AxiosError | null },
]

export type MarcarTodasAsNotificacoesComoVisualizadasResposta = [
  () => Promise<boolean>,
  { loading: boolean; erro: AxiosError | null },
]
